import { useState } from 'react';
import axios from 'axios';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { API } from './_helpers';

export default function NewShiftModal({ initial, staff, sites, onClose, onSaved }) {
  const [date, setDate] = useState(initial.date);
  const [userId, setUserId] = useState(initial.user_id || '');
  const [start, setStart] = useState('08:30');
  const [end, setEnd] = useState('17:00');
  const [role, setRole] = useState('');
  const [siteId, setSiteId] = useState((sites && sites.find(s => s.active)?.site_id) || '');
  const [location, setLocation] = useState('');
  const [notes, setNotes] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const submit = async () => {
    setBusy(true); setErr('');
    try {
      await axios.post(`${API}/roster/shifts`,
        { date, start, end, user_id: userId, role_label: role || null,
          site_id: siteId || null, location: location || null, notes: notes || null },
        { withCredentials: true });
      onSaved();
    } catch (e) {
      setErr(e?.response?.data?.detail || 'Could not save'); setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-xl max-w-md w-full p-5 shadow-xl" onClick={e => e.stopPropagation()}>
        <h3 className="text-lg font-bold mb-3">New shift</h3>
        <div className="space-y-3">
          <label className="block text-xs font-semibold text-muted-foreground">Staff member
            <select value={userId} onChange={e => setUserId(e.target.value)} data-testid="new-shift-user"
              className="mt-1 w-full border rounded-md px-3 py-2 text-sm bg-white">
              <option value="">— Choose —</option>
              {staff.map(s => <option key={s.id} value={s.id}>{s.name} ({s.role || ''})</option>)}
            </select>
          </label>
          <div className="grid grid-cols-3 gap-2">
            <label className="text-xs font-semibold text-muted-foreground">Date
              <Input type="date" value={date} onChange={e => setDate(e.target.value)} className="mt-1" />
            </label>
            <label className="text-xs font-semibold text-muted-foreground">Start
              <Input type="time" value={start} onChange={e => setStart(e.target.value)} className="mt-1" />
            </label>
            <label className="text-xs font-semibold text-muted-foreground">End
              <Input type="time" value={end} onChange={e => setEnd(e.target.value)} className="mt-1" />
            </label>
          </div>
          <Input value={role} onChange={e => setRole(e.target.value)} placeholder="Role label (e.g. CT Radiographer)" />
          {sites && sites.length > 0 ? (
            <label className="block text-xs font-semibold text-muted-foreground">Site
              <select value={siteId} onChange={e => setSiteId(e.target.value)} data-testid="new-shift-site"
                className="mt-1 w-full border rounded-md px-3 py-2 text-sm bg-white">
                <option value="">— No site —</option>
                {sites.filter(s => s.active).map(s => <option key={s.site_id} value={s.site_id}>{s.name}</option>)}
              </select>
            </label>
          ) : (
            <Input value={location} onChange={e => setLocation(e.target.value)} placeholder="Location" />
          )}
          <Textarea value={notes} onChange={e => setNotes(e.target.value)} rows={2} placeholder="Notes (optional)" />
          {err && <div className="text-xs text-red-600">{err}</div>}
        </div>
        <div className="flex justify-end gap-2 mt-5">
          <button onClick={onClose} className="text-sm font-semibold px-4 py-2 rounded-lg border">Cancel</button>
          <button onClick={submit} disabled={!userId || busy} data-testid="new-shift-save"
            className="text-sm font-semibold px-4 py-2 rounded-lg bg-[#0d2644] text-white disabled:opacity-50">
            {busy ? 'Saving…' : 'Save draft'}
          </button>
        </div>
      </div>
    </div>
  );
}
